export const CustomerDocumentType: {
    ANAMNESE: 'ANAMNESE',
    INFORMED_CONSENT: 'INFORMED_CONSENT',
    BLOOD_REPORT: 'BLOOD_REPORT',
    OTHER: 'OTHER',
} = {
    ANAMNESE: 'ANAMNESE',
    INFORMED_CONSENT: 'INFORMED_CONSENT',
    BLOOD_REPORT: 'BLOOD_REPORT',
    OTHER: 'OTHER',
};

export type CustomerDocumentType = (typeof CustomerDocumentType)[keyof typeof CustomerDocumentType];

export const getCustomerDocumentTypeLabel = (type: CustomerDocumentType): string => {
    if (type === CustomerDocumentType.ANAMNESE) {
        return 'Anamnese';
    }
    if (type === CustomerDocumentType.INFORMED_CONSENT) {
        return 'Einwilligungserklärung';
    }
    if (type === CustomerDocumentType.BLOOD_REPORT) {
        return 'Blutbefund';
    }
    if (type === CustomerDocumentType.OTHER) {
        return 'Sonstiges';
    }
    return 'Unbekannter Dokumenttyp';
};